export enum AdviserEditLevel {
  None = 'none',
  Basic = 'basic',
  All = 'all',
}

export const getAdviserEditLevel = (
  isSuperAdmin: boolean,
  hasMoreThanOneLinkedFirm: boolean,
  firmId?: string,
): AdviserEditLevel => {
  if (isSuperAdmin) return AdviserEditLevel.All;
  if (!firmId) return AdviserEditLevel.None;
  if (!hasMoreThanOneLinkedFirm) return AdviserEditLevel.All;

  return AdviserEditLevel.Basic;
};

export const canDeleteAdviser = (
  isSuperAdmin: boolean,
  adviserData: {
    investmentsCount: number;
    associatedFirms: Array<{ _id: string }>;
  },
  firmId: string,
  deletePermission: boolean,
) => {
  const isSuperAdminAndNoInvestments =
    isSuperAdmin && !adviserData.investmentsCount;
  const isAdviserLinkedToSingleFirmAndNoInvestments =
    adviserData?.associatedFirms?.length === 1 &&
    adviserData.associatedFirms[0]._id === firmId &&
    !adviserData?.investmentsCount;

  return (
    deletePermission &&
    (isSuperAdminAndNoInvestments ||
      isAdviserLinkedToSingleFirmAndNoInvestments)
  );
};
